<template>
  <svg
    width="462"
    height="150"
    viewBox="0 0 462 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M74.8956 146.925V117.091H3.50685L0.523438 92.7978L68.2895 0.738281H106.435V90.6668H125.827V117.091H106.435V146.925H74.8956ZM33.5541 90.6668H74.8956V33.982L33.5541 90.6668Z"
      fill="#0A45E7"
    />
    <path
      d="M155.755 0.738281H306.236C311.776 0.738281 316.271 5.23332 316.271 10.7729V146.924H145.727V10.7729C145.727 5.23332 150.222 0.738281 155.761 0.738281H155.755Z"
      fill="#D9E3F9"
    />
    <path d="M305.098 11.9473H156.898V146.724H305.098V11.9473Z" fill="white" />
    <path
      d="M305.072 11.5801H156.922V51.2988H305.072V11.5801Z"
      fill="#A9BFED"
    />
    <path d="M305.072 37.6074H156.922V39.3731H305.072V37.6074Z" fill="white" />
    <path d="M305.072 23.916H156.922V25.6817H305.072V23.916Z" fill="white" />
    <path
      d="M133.828 146.924H328.172"
      stroke="#B0C9E9"
      stroke-width="6"
      stroke-miterlimit="10"
    />
    <mask
      id="mask0_17148_206496"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="156"
      y="51"
      width="150"
      height="96"
    >
      <path
        d="M305.098 51.2988H156.898V146.724H305.098V51.2988Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_17148_206496)">
      <path
        d="M230.895 143.926C194.366 143.926 168.734 114.259 168.734 72.078C168.734 30.0993 194.366 0.431641 230.895 0.431641C267.425 0.431641 293.258 30.0993 293.258 72.078C293.258 114.259 267.425 143.926 230.895 143.926ZM230.895 116.882C249.665 116.882 262.581 98.1129 262.581 72.078C262.581 46.0432 249.665 27.4756 230.895 27.4756C212.328 27.4756 199.209 46.0432 199.209 72.078C199.209 98.1129 212.328 116.882 230.895 116.882Z"
        fill="#0A45E7"
      />
    </g>
    <path
      d="M410.544 146.925V117.091H339.155L336.172 92.7978L403.938 0.738281H442.083V90.6668H461.475V117.091H442.083V146.925H410.544ZM369.202 90.6668H410.544V33.982L369.202 90.6668Z"
      fill="#0A45E7"
    />
  </svg>
</template>
